<template>
  <div class="DataInfo padding3 bc-white" v-title data-title="数据统计">
    <div class="text-left font-bold pt5">选择日期范围</div>
    <div class="row padding3 align-items-center">
      <div class="fc-less pr3">快速</div>
      <div class="flex-1 row">
        <div v-for="(item, index) in dates" :key="item.name" class="col-8 padding3">
          <div @click="clickItem(index)"
            class="date-item"
            :class="selectedDateIndex===index?'date-item-active':''">{{item.name}}</div>
        </div>
      </div>
    </div>
    <div class="row padding3 align-items-center pb7">
      <div class="fc-less pr3">自选</div>
      <div class="pl3" @click="changeDate()">
        {{formatDate(start)}}
      </div>
      <van-icon  @click="changeDate()" name="arrow-down" size=""/>
      <div class="flex-1 pl3 text-center">至</div>
      <div class="pl3" @click="changeDate(true)">
        {{formatDate(end)}}
      </div>
      <van-icon  @click="changeDate(true)" name="arrow-down" size=""/>
    </div>
    <div class="line-top"></div>
    <div class="row pt5">
      <div v-for="item in datas" :key="item.name" class="col-12 padding3">
        <div class="data-item" :style="{'background-color': item.color1}">
          <div class="pt8 fs10">{{item.name}}</div>
          <div class="pt5 fs11">{{item.value || 0}}<span class="fs10">次</span></div>
        </div>
      </div>
    </div>
    <div class="row justify-content-around pr10 pl10 pt5 pb5">
      <van-button @click="back" class="btn-common" plain type="info">返回</van-button>
      <!-- <van-button @click="saveNotice" class="btn-common" type="info">保存</van-button> -->
    </div>
    <!-- 日期弹出 -->
    <van-popup
      v-model="startshow"
      position="bottom"
    >
      <van-datetime-picker
        v-model="start"
        type="date"
        :formatter="formatter"
        @confirm="confirmDate()"
        @cancel="cancelDate()"
      />
    </van-popup>
    <van-popup
      v-model="endshow"
      position="bottom"
    >
      <van-datetime-picker
        v-model="end"
        type="date"
        :formatter="formatter"
        @confirm="confirmDate(true)"
        @cancel="cancelDate(true)"
      />
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue';
import { sendRequest, accessrecord } from '../network/NetworkAccessor';

const day = 1000 * 60 * 60 * 24;
export default Vue.extend({
  name: 'DataInfo',
  components: {},
  data() {
    return {
      startshow: false,
      endshow: false,
      selectedDateIndex: 0,
      start: new Date(),
      end: new Date(),
      dates: [
        {
          name: '当天',
          value: 0,
        },
        {
          name: '近7天',
          value: 6,
        },
        {
          name: '近30天',
          value: 29,
        },
      ],
      datas: [
        {
          name: 'UV',
          value: 0,
          color1: '#3295db',
          color2: '#ffebb1',
        },
        {
          name: 'PV',
          value: 0,
          color1: '#71b16b',
          color2: '#0b85bb',
        },
      ],
    };
  },
  methods: {
    formatDate(date) {
      if (!date) {
        return '';
      }
      const month = date.getMonth() + 1;
      const monthStr = month > 9 ? month : `0${month}`;
      const d = date.getDate();
      const dStr = d > 9 ? d : `0${d}`;
      const datestr = `${date.getFullYear()}-${monthStr}-${dStr}`;
      // console.log(datestr);
      return datestr;
    },
    changeDate(flag) {
      this.startshow = false;
      this.endshow = false;
      if (flag) {
        this.endshow = true;
      } else {
        this.startshow = true;
      }
    },
    confirmDate() {
      this.startshow = false;
      this.endshow = false;
      // console.log(this.start, this.end);
      this.start = new Date(this.formatDate(this.start));
      this.end = new Date(this.formatDate(this.end));
      const days = (this.start - this.end) / day;
      this.selectedDateIndex = this.formatDate(this.end) === this.formatDate(new Date()) ? this.dates.findIndex(d => days === d.value) : -1;
      this.getDataInfo();
    },
    cancelDate() {
      this.startshow = false;
      this.endshow = false;
      // console.log(this.start, this.end);
    },
    formatter(type, value) {
      if (type === 'year') {
        return `${value}年`;
      }
      if (type === 'month') {
        return `${value}月`;
      }
      return value;
    },
    clickItem(index) {
      this.selectedDateIndex = index;
      this.end = new Date();
      this.start = new Date(this.end.getTime() - day * this.dates[index].value);
      this.getDataInfo();
    },
    getDataInfo() {
      sendRequest(accessrecord, {
        startDate: this.formatDate(this.start),
        endDate: this.formatDate(this.end),
      }).then((res) => {
        // console.log(res);
        const { datas } = this;
        datas[0].value = res.uv;
        datas[1].value = res.pv;
        this.datas = datas;
      }).catch((e) => {
        console.log(e);
        this.$dialog.alert({
          message: e.message || '啊哦，出错了',
        });
      });
    },
    back() {
      this.$router.back();
    },
  },
  created() {
    this.getDataInfo();
  },
});
</script>
<style scoped>
  .DataInfo {
    min-height: 100vh;
  }
  .data-item {
    height: 120px;
    border-radius: 6px;
    /* background-color: #0b85bb; */
    color: #ffffff;
  }
  .date-item {
    border: 1px solid #eeeeee;
    border-radius: 16px;
    padding: 4px 6px;
    background-color: #eeeeee;
    font-size: 14px;
  }
  .date-item-active {
    border: 1px solid #1989fa;
    color: #1989fa;
    background-color: rgba(25, 137, 250, 0.05);
  }
  .line-top {
    border-top: 1px solid #e6e1e1;
    width: 100%;
    height: 0;
  }
</style>
